import type { ScanEventKind } from './types'

/** Пояснение к событию с новым фото: оно поставлено в очередь индексации, но «уже находится» пока не обещаем. */
export const INDEX_QUEUED_NOTE = 'фото в индексе: через несколько секунд'

/** Слова для ленты. Название товара в кавычках-ёлочках; пустое название не выдумывается. `indexQueued` — добавляет пояснение про индекс. */
export function scanEventText(kind: ScanEventKind, productName: string | null, indexQueued = false): string {
  const text = scanEventBase(kind, productName)
  return indexQueued ? `${text} — ${INDEX_QUEUED_NOTE}` : text
}

function scanEventBase(kind: ScanEventKind, productName: string | null): string {
  const quoted = productName === null || productName.trim() === '' ? 'товару' : `«${productName.trim()}»`
  switch (kind) {
    case 'created':
      return productName === null || productName.trim() === '' ? 'Товар создан' : `Создан ${quoted}`
    case 'attached':
      return productName === null || productName.trim() === '' ? 'Фото прикреплено' : `Фото прикреплено к ${quoted}`
    case 'found':
      return productName === null || productName.trim() === '' ? 'Товар найден' : `Найден ${quoted}`
    case 'skipped':
      return 'Кадр пропущен'
    case 'failed':
      return productName === null || productName.trim() === '' ? 'Не сохранено — повторить' : `Не сохранено — повторить: ${quoted}`
  }
}
